const initialState = {
  fetching: false,
  fetched: false,
  updating: false,
  updated: false,
  items: [],
  error: null,
  nbResult: 0
};

const getUsersInfos = users => {
  return users.map(user => ({
    ...user,
    firstName: user.firstName[0].toUpperCase() + user.firstName.slice(1),
    lastName: user.lastName[0].toUpperCase() + user.lastName.slice(1)
    // title: user.firstName + " " + user.lastName
  }));
};

export const authorizationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_USERS_SETTINGS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_USERS_SETTINGS_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: getUsersInfos(data),
        nbResult: nbResult,
        filter: { ...state.filter }
      };
    }
    case "FETCH_USERS_SETTINGS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case "canceled":
          return state;
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }

      return {
        ...state,
        fetching: false,
        items: [],
        error
      };
    }
    case "SAVE_USERS_PENDING": {
      return { ...state, updated: false, updating: true };
      // eslint-disable-next-line no-unreachable
      break;
    }
    case "UPDATE_USERS": {
      return {
        ...state,
        updating: false,
        updated: true,
        items: state.items.map(
          item =>
            action.payload.selectedUsers.includes(item.id)
              ? {
                  ...item,
                  dataAuthorization: action.payload.role
                    ? {
                        role: action.payload.role,
                        preferences: {
                          allowCreateDashboard:
                            action.payload.allowCreateDashboard,
                          allowAccessToDashboardList:
                            action.payload.allowAccessToDashboardList,
                          allowAssociateDashboards:
                            action.payload.allowAssociateDashboards,
                          allowAccessToCollaboratorList:
                            action.payload.allowAccessToCollaboratorList,
                          allowUpdateSlide: action.payload.allowUpdateSlide,
                          allowCreateSlide: action.payload.allowCreateSlide,
                          allowAccessToSlideList:
                            action.payload.allowAccessToSlideList,
                          allowAccessToSettings:
                            action.payload.allowAccessToSettings,
                          allowUpdateDashboard:
                            action.payload.allowUpdateDashboard
                        }
                      }
                    : []
                }
              : item
        )
      };
      // eslint-disable-next-line no-unreachable
      break;
    }
    case "SAVE_USERS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        updated: false,
        updating: false,
        error
      };
    }
    case "INIT_SAVE_USERS": {
      return {
        ...state,
        updating: false,
        updated: false
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authorizations.js